<script>
import TwButton from '@/components/generic/tw-button.vue'

export default {
  name: 'HomeSliderSecondary',
  components: { TwButton }
}
</script>

<template>
  <div class="px-4 py-10 mb-4 md:py-24 md:my-6 text-black text-center">
    <h5>
      #1 free fundraising platform for groups & teams
    </h5>
    <div class="my-5 mx-auto max-w-4xl">
      <h1 class="font-light">
        Unleash the Power of <span class="text-amber-500">Peer to Peer Fundraising</span> for Your Organization
      </h1>
    </div>
    <div class="mt-10 flex justify-center gap-3 md:gap-4">
      <tw-button :to="{name: 'StaticForOrganizationsPage'}" variant="amber" size="xl" class="px-24 py-5 font-light">
        Get Started
      </tw-button>
      <tw-button :to="{name: 'StaticHowItWorksPage'}" size="xl" variant="outline" class="px-24 py-5 font-light">
        How it Works
      </tw-button>
    </div>
  </div>
</template>

<style scoped>

</style>
